import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { CTAButton } from "../CTAButton";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16" data-id="element-129" data-mp="2z2p6yys9pdtb">
      <div className="mx-auto max-w-2xl" data-id="element-130" data-mp="2z3h1e6a4p5i0">
        <h2 className="text-center font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-131" data-mp="3mt2xulz496mb">
          Frequently asked questions
        </h2>
        <ul className="mt-8 space-y-3" data-id="element-132" data-mp="3rr4hp94d99yu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-cream" data-id="element-133" data-mp="3i1tchxklopg8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-134" data-mp="3hzqcckpqhfxs">
                  <span className="text-[16px] font-bold leading-snug text-ink" data-id="element-135" data-mp="1vsye0a98u2ir">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden data-id="element-136" data-mp="2ahl333ooa8n6" />
                </button>
                <AnimatePresence initial={false} data-id="element-137" data-mp="2jj17must3gjh">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-138" data-mp="2ek7qmseb97ek">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-muted" data-id="element-139" data-mp="z37luhofcrg4">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <CTAButton className="mt-10" label="I’m ready — get the Atlas™" data-id="element-140" data-mp="1nrhb0yd54nkc" />
      </div>
    </section>;
}